export const exploContent = (
  <>
    <div className="prose dark:prose-invert max-w-none">
      <p>
        EXPLO, an immersive summer program for middle schoolers, partnered with
        Township to fully redesign their onboarding process for kids and
        parents.
      </p>
      <p>
        When the process began, EXPLO relied on a series of third-party tools to
        manage the various forms, applications, waivers, and permissions
        required for every camper. Township was able to design a streamlined
        flow that transformed the application process into a user-friendly,
        single application.
      </p>
    </div>
  </>
);
